<template>
  <div class="w-full">
    <p class="font-bold text-md md:text-lg mb-2">Selamat Datang di Halaman Admin Sekolah Desain</p>
    <div class="border-2 border-gray-400 rounded-xs p-3">
      <div class="bg-white shadow-md rounded p-4 w-full">
        <div class="flex justify-between w-full">
          <div class="flex items-center mb-2">
            <i class="fas fa-calendar-alt mr-1" />
            <p>Jadwal Webinar </p>
          </div>
          <div class="text-xs">
            <div class="flex pb-1 items-center">
              <div class="bg-yellow-500 w-3 h-3 mr-1 rounded-sm"></div>
              <p>Webinar Biasa</p>
            </div>
            <div class="flex pb-1 items-center">
              <div class="bg-green-500 w-3 h-3 mr-1 rounded-sm"></div>
              <p>Webinar Plus</p>
            </div>
          </div>
        </div>
        <v-calendar
          class="custom-calendar w-full"
          transition="slide-h"
          :masks="masks"
          :attributes="attributes"
          disable-page-swipe
          is-expanded
          @update:from-page="pageChange"
        >
          <template v-slot:day-content="{ day, attributes }">
            <div class="flex flex-col h-full z-10 overflow-hidden">
              <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
              <span v-if="attributes?.length > 0" class="absolute top-0 right-0 mt-1 mr-1 text-xs bg-purple-800 text-white px-1 rounded-full">{{ attributes?.length }}</span>
              <div class="flex-grow overflow-y-auto overflow-x-auto">
                <div
                  v-for="(attr, i) in attributes"
                  :key="i"
                  class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                >
                  <div v-if="attr.customData.is_plus" v-tooltip.top="attr.customData.name+` (`+attr.customData.classroom.code+`)`" class="w-full p-1 font-bold bg-green-400 cursor-pointer rounded-lg  shadow-xl border-2 border-gray-500 hover:bg-green-500" @click="showDetailWebinar(attr)">
                    <p class="text-xs class-title mb-0">{{attr.customData.classroom.name }}</p>
                    <p class="text-xs font-medium">
                      {{ attr.customData.started_at.substring(11, 16)  + ' - '  +  attr.customData.expired_at.substring(11, 16) }} WIB
                    </p>
                  </div>
                  <div v-else v-tooltip.top="attr.customData.name+` (`+attr.customData.classroom.code+`)`" class="w-full p-1 font-bold bg-yellow-400 cursor-pointer rounded-lg  shadow-xl border-2 border-gray-500 hover:bg-yellow-500" @click="showDetailWebinar(attr)">
                    <p class="text-xs class-title mb-0">{{attr.customData.classroom.name }}</p>
                    <p class="text-xs font-medium">
                      {{ attr.customData.started_at.substring(11, 16)  + ' - '  +  attr.customData.expired_at.substring(11, 16) }} WIB
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </v-calendar>

        <!-- Webinar Schedule Per-Week -->
        <!-- <div class="flex justify-between">
          <div>
            <i class="fas fa-video mr-1" />
            <span class="text-md">Webinar Minggu Ini</span>
          </div>
          <div class="flex items-center">
            <i @click="prevSchedule" v-if="today.format('YYYY-MM-DD') < from_date.format('YYYY-MM-DD')"
              class="fas text-2xl fa-arrow-circle-left cursor-pointer hover:text-red-400"></i>
            <span class="mx-2">{{from_date.format('MMMM DD')}} - {{to_date.format('MMMM DD')}}</span>
            <i @click="nextSchedule" class="fas text-2xl fa-arrow-circle-right cursor-pointer hover:text-red-400"></i>
          </div>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-7 gap-0.5 mt-5" v-if="!loadingSch">
          <div v-for="day in range" :key="day.date"
            :class="day.date == today.format('YYYY-MM-DD') ? 'bg-red-400' : 'bg-red-200' ">
            <div class="w-full p-1 font-bold text-red-50"
              :class="day.date == today.format('YYYY-MM-DD') ? 'bg-red-800' : 'bg-red-500' ">
              <p class="mb-0">{{day.day}}</p>
              <p class="mb-0">{{day.nameDay}} </p>
            </div>
            <div class="p-1">
              <router-link :to="'/classroom/' + sch.classroom.id + '/webinar'" v-for="(sch, index) in schedule"
                :key="index" class="w-full cursor-pointer mb-2 ">
                <div v-if="day.date == sch.started_at.substring(0, 10)"
                  class="p-1 mb-2 rounded-md  shadow-xl border-2 border-gray-500 bg-yellow-400 hover:bg-yellow-600"
                  >
                  <p v-tooltip.top="sch.classroom.name" class="text-xs class-title mb-0">{{sch.classroom.name }}</p>
                  <p class="text-xs font-bold">{{sch.classroom.code}}</p>
                  <p class="text-sm font-bold">
                    {{ sch.started_at.substring(11, 16)  + ' - '  +  sch.expired_at.substring(11, 16) }} WIB</p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div v-else class="p-5 text-center font-bold ">
          Loading...
        </div> -->
      </div>

      
      <div class="bg-white shadow-md rounded p-4 w-full mt-5">
        <div class="md:flex justify-between pb-4">
          <div>
            <i class="fas fa-chart-bar mr-2" />
            <span class="text-md">Statistik User Baru</span>
          </div>
          <div>
            <litepie-datepicker use-range separator=" - " v-model="reportDate" v-slot="{ value, placeholder, clear }"
              :formatter="dateFormatter" placeholder="7 hari terakhir">
              <span class="p-input-icon-right">
                <i :class="['pi', { 'pi-calendar': !value, 'pi-times': value }]" @click="clear" />
                <InputText :value="value || placeholder" :placeholder="placeholder"
                  class="font-sans text-sm rounded-md py-2" />
              </span>
            </litepie-datepicker>
          </div>
        </div>
        <LineChart :chartData="chartData" />
        <!-- <UserReportChart :chartData="chartData" :width="350" :height="80" /> -->
      </div>

      <div class="bg-white shadow-md rounded p-4 w-full mt-5">
        <div class="mb-2">
          <i class="fas fa-chart-bar mr-2" />
          <span class="text-md">Statistik Transaksi</span>
        </div>
        <div class="md:flex items-center pb-4">
          <!-- <PieTransaction :chartData="transactionData" :width="300" :height="300" :chartOptions="chartOptions" /> -->
          <PieChart :chartData="transactionData" :chartOptions="chartOptions" />
          <div class="md:ml-5">
            <p class="mb-3"> <span class="rounded-green"></span> : Transaksi Berhasil
              ({{(transactionSummary.paid / transactionSummary.total * 100).toFixed(2)}}%) </p>

            <p class="mb-3"> <span class="rounded-red"></span> : Transaksi Gagal
              ({{(transactionSummary.unpaid  / transactionSummary.total * 100).toFixed(2)}}%) </p>
            <p> <span class="rounded-total"> </span> : Total Transaksi ({{numberWithCommas(transactionSummary?.total)}} Transaksi)</p>
          </div>
        </div>
      </div>
    </div>
    
    <div
      v-if="forbidden"
      class="fixed inset-0 w-full h-full bg-black bg-opacity-50 duration-300 overflow-y-auto"
      style="z-index: 2;"
      x-show="forbidden"
      x-transition:enter="transition duration-300"
      x-transition:enter-start="opacity-0"
      x-transition:enter-end="opacity-100"
      x-transition:leave="transition duration-300"
      x-transition:leave-start="opacity-100"
      x-transition:leave-end="opacity-0"
    >
      <div class="relative sm:w-3/4 md:w-1/2 lg:w-1/3 mx-auto sm:mx-auto opacity-100 h-screen justify-center items-center" style="display: flex;">
        <div
          class="relative bg-white shadow-2xl rounded-md text-gray-900 z-20 p-2"
          @click="forbiddenClose"
          x-show="forbidden"
          x-transition:enter="transition transform duration-300"
          x-transition:enter-start="scale-0"
          x-transition:enter-end="scale-100"
          x-transition:leave="transition transform duration-300"
          x-transition:leave-start="scale-100"
          x-transition:leave-end="scale-0"
        >
          <header class="flex items-center justify-between">
            <h2 class="font-semibold text-xl text-red-500">Peringatan !</h2>
            <button class="focus:outline-none p-2" @click="forbiddenClose">
              <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18">
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                ></path>
              </svg>
            </button>
          </header>
          <main class="px-2 py-5 text-center">
            <p class="text-lg">
            Menu yang ingin anda akses tidak tersedia untuk akun ini
            </p>
          </main>
          <footer class="flex justify-center p-2">
            <button
              class="bg-red-600 font-semibold text-white p-2 w-32 rounded-full hover:bg-red-700 focus:outline-none focus:ring shadow-2xl hover:shadow-none transition-all duration-300"
              @click="forbiddenClose"
            >
              Kembali
            </button>
          </footer>
        </div>
      </div>
    </div>

    <!-- modal webinar -->
    <transition name="fade">
      <div 
        v-if="displayDetailWebinar"
        class="opacity-30 fixed inset-0 z-51 bg-black"
      ></div>
    </transition>
    <transition name="pop">
    <div v-if="displayDetailWebinar"
      class="overflow-x-hidden overflow-y-auto fixed inset-0 z-51 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-3/4 md:w-2/5 m-auto">
        <div v-click-away="closeDetailWebinar" class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div
            class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
            <div class="">
              <h3 class="text-xl font-semibold text-white">
                Detail Webinar
              </h3>
            </div>
            <button
              class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
              v-on:click="closeDetailWebinar">
              <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
            </button>
          </div>
          <div class="relative px-6 pt-3 pb-6">
            <!-- <div class="p-2">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Kelas {{detailWebinar?.customData?.classroom?.name}}
              </h3>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                {{ detailWebinar?.customData?.name }}
              </p>
            </div> -->
            <div class="w-full grid gap-2 border border-gray-300">
              <dl>
                <div class="bg-gray-50 px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Nama Webinar
                  </dt>
                  <dd class="mt-1 text-sm text-indigo-600 hover:text-indigo-800 font-medium sm:mt-0 sm:col-span-2">
                    <router-link :to="'/classroom/' + detailWebinar?.customData.classroom?.id + '/webinar?webinar_id=' + detailWebinar?.customData.id" class="w-full cursor-pointer">
                      {{detailWebinar?.customData?.name}}
                      <i class="fas fa-external-link-alt"></i>
                    </router-link>
                  </dd>
                </div>
                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Webinar Ke-
                  </dt>
                  <dd class="mt-1 text-sm sm:mt-0 sm:col-span-2">
                    {{detailWebinar?.customData?.ordering}}
                  </dd>
                </div>
                <div class="bg-gray-50 px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Kelas
                  </dt>
                  <dd class="mt-1 text-sm text-indigo-600 hover:text-indigo-800 font-medium sm:mt-0 sm:col-span-2">
                    <router-link :to="'/classroom/' + detailWebinar?.customData.classroom?.id + '/detail'" class="w-full cursor-pointer">
                      {{detailWebinar?.customData?.classroom?.name}} ({{ detailWebinar?.customData?.classroom?.code }})
                      <i class="fas fa-external-link-alt"></i>
                    </router-link>
                  </dd>
                </div>
                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Mentor
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <div class="flex" v-for="(mentor, i) in detailWebinar?.customData?.mentors" :key="i">
                      <p>{{ i+1 }}. {{ mentor.name }}</p>
                    </div>
                  </dd>
                </div>
                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Room Link
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <a v-if="detailWebinar?.customData?.room?.link" :href="detailWebinar?.customData?.room?.link"
                      class="text-blue-600 break-words" target="_blank">{{detailWebinar?.customData?.room?.link}}</a>
                    <span v-else>-</span>
                  </dd>
                </div>
                <div class="bg-gray-50 px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Room Password
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span v-if="detailWebinar?.customData?.room?.password"
                      class="">{{detailWebinar?.customData?.room?.password}}</span>
                    <span v-else>-</span>
                  </dd>
                </div>
                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Room Email
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span v-if="detailWebinar?.customData?.room?.email"
                      class="">{{detailWebinar?.customData?.room?.email}}</span>
                    <span v-else>-</span>
                  </dd>
                </div>
                <div class="bg-gray-50 px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Tanggal Berlangsung
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span>{{ formatDate(detailWebinar?.customData?.started_at) }}</span>
                  </dd>
                </div>

                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3">
                  <dt class="text-sm font-medium text-gray-500">
                    Jam Berlangsung
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span>{{ formatHours(detailWebinar?.customData?.started_at) }} - {{ formatHours(detailWebinar?.customData?.expired_at) }} WIB</span>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition>
    <Toast />
  </div>
</template>
<script>
/* eslint-disable */
import {
  mapActions,
  mapGetters
} from 'vuex'
import UserReportChart from "../User/components/UserReportChart.vue"
import PieTransaction from "@/layout/Component/Chart/PieTransaction.vue"
import LitepieDatepicker from 'litepie-datepicker'
import {
  Classroom
} from '@/api/classroom.js'
import moment from 'moment'

import { Chart, registerables } from 'chart.js';
import { LineChart, PieChart } from 'vue-chart-3';
Chart.register(...registerables);

export default {
  name:"Dashboard",
  components: {
    UserReportChart,
    LitepieDatepicker,
    PieTransaction,
    LineChart,
    PieChart,
  },
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: [],
      dateFormatter: {
        date: 'DD-MM-YYYY',
        month: 'MMM'
      },
      reportDate: {
        startDate: null,
        endDate: null,
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        }
      },
      today: moment(),
      from_date: moment().startOf('week'),
      to_date: moment().endOf('week'),
      startOfMonth: moment().startOf('month').format('YYYY-MM-DD'),
      endOfMonth: moment().endOf('month').format('YYYY-MM-DD'),
      schedule: [],
      flag: '',
      range: [],
      loadingSch: true,
      forbidden: false,
      detailWebinar: {},
      displayDetailWebinar: false,
    }
  },
  async created() {
      this.fetchUserReport()
      this.fetchSummaryTransaction()
      await this.monthSchedule()
  },
  
  computed: {
    ...mapGetters([
      "transactionSummary",
      "userReport",  
    ]),
    transactionData() {
      const transactionPaid = this.transactionSummary.paid
      const transactionUnpaid = this.transactionSummary.unpaid
      return {
        labels: ['Gagal', 'Berhasil'],
        datasets: [
          {
            label: '',
            data: [transactionUnpaid, transactionPaid],
            backgroundColor: ['#EF4444', '#34D399']
          },
        ]
      }
    },
    chartData() {
      const reportData = this.userReport;
    //   console.log(reportData)

      return {
        labels: reportData.map((data) => data.date),
        datasets: [
          {
            label: "User",
            backgroundColor: "#f87979",
            data: reportData.map((data) => data.total),
          },
        ],
      };
    },
  },
  mounted() {
    // this.getSchedule()
    if(this.$route.query.forbidden) {
      this.forbidden = true
    }
  },
  methods: {
    ...mapActions(["fetchUserReport", "fetchSummaryTransaction"]),
    pageChange(event) {
      const dateChange = event.year+'-'+event.month+'-1'
      this.startOfMonth = moment(dateChange, 'YYYY-MM-DD').format('YYYY-MM-DD')
      this.endOfMonth = moment(dateChange, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')
      this.monthSchedule()
    },
    forbiddenClose() {
      this.forbidden = false
      if(this.$route.query.forbidden) {
         this.$router.push('/dashboard')
      }
    },
    prevSchedule() {
      this.range = []
      this.from_date.subtract(1, 'weeks')
      this.to_date.subtract(1, 'weeks')
      this.getSchedule()
    },

    nextSchedule() {
      this.range = []
      this.from_date.add(1, 'weeks')
      this.to_date.add(1, 'weeks')
      this.getSchedule()
    },
    async monthSchedule() {
      this.attributes = []
      await Classroom.getAdminWebinar(this.startOfMonth, this.endOfMonth)
      .then(res => {
        if(res.data.success) {
          const arr = res.data.data.sort(function(a, b) {
            var keyA = new Date(a.started_at),
              keyB = new Date(b.started_at);
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
          const schedule = []
          if(arr.length > 0) {
            arr.forEach((el, i) => {
              const date = moment(el.started_at).format('YYYY-MM-DD 00:00:00')
              const payload = {
                key: i+1,
                customData: el,
                dates: new Date(date),
              }
              schedule.push(payload)
            })
          }
          this.attributes = schedule
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Failed',
            detail: 'Terjadi Kesalahan'
          })
        }
      })
      .catch(err => {
        this.$toast.add({
          severity: 'error',
          summary: 'Failed',
          detail: err.errors[0].message
        })
      })
    },
    showDetailWebinar(data) {
      this.detailWebinar = data
      this.displayDetailWebinar = true
    },
    closeDetailWebinar() {
      this.displayDetailWebinar = false
      this.detailWebinar = null
    },
    async getSchedule() {
      this.loadingSch = true
      const start = this.from_date.format('YYYY-MM-DD')
      const end = this.to_date.format('YYYY-MM-DD')
      await Classroom.getAdminWebinar(start, end).then( res => {
        if(res.data.success) {
          const arr = res.data.data.sort(function(a, b) {
            var keyA = new Date(a.started_at),
              keyB = new Date(b.started_at);
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
          this.loadingSch = false
          this.schedule = arr
        //  console.log('data', this.schedule)
        }
        
      })  
    
      const formatStart = moment(start, 'YYYY-MM-DD')
      this.flag = formatStart
      for (let i = 1; i <= 7; i++) {
        this.range.push({
          date: this.flag.format('YYYY-MM-DD'),
          day: this.flag.format('DD'),
          nameDay: this.flag.format('dddd'),
        })
        this.flag.add(1, 'd')
      }
      // console.log(this.range)
    },
    formatDate(date) {
      return moment(date).locale('id').format('dddd, DD MMMM YYYY')
    },
    formatHours(date) {
      return moment(date).locale('id').format('HH:mm')
    },
    numberWithCommas(x) {
      return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  watch: {
    reportDate(val) {
      this.fetchUserReport(val);
    }
  }
}
</script>
<style lang="css" scoped>
.rounded-green, .rounded-red, .rounded-total {
  padding: 5px 13px;
  border: 2px solid #000;
  border-radius: 50%;
  margin-right: 10px;
}
.rounded-green {
  background: #34D399;
}
.rounded-red {
  background: #EF4444;
}
.rounded-total {
  background: #fff;
}
.class-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  float: left;
}

::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}
::v-deep(.vc-container) {
  border-radius: 0;
  width: 100%;
}
::v-deep(.vc-header) {
  background-color: #f1f5f8;
  padding: 10px 0;
}
::v-deep(.vc-container .vc-header) {
  background-color: #f1f5f8;
  padding: 10px 0;
}
::v-deep(.vc-container .vc-weeks) {
  padding: 0;
}
::v-deep(.vc-container .vc-weekday) {
  background-color: #f8fafc;
  border-bottom: 1px solid #eaeaea;
  border-top: 1px solid #eaeaea;
  padding: 5px 0;
}
::v-deep(.vc-container .vc-day) {
  padding: 0 5px 3px 5px;
  text-align: left;
  min-height: 90px;
  min-width: 90px;
  background-color: white;
}
@media (max-width: 500px) {
  ::v-deep(.vc-container .vc-day) {
    padding: 0 5px 3px 5px;
    text-align: left;
    min-height: 20px;
    min-width: 20px;
    background-color: white;
  }
}
/* ::v-deep(.vc-container .vc-day.weekday-1, .vc-container .vc-day.weekday-7) {
  background-color: #eff8ff;
} */
::v-deep(.vc-container .vc-day:not(.on-bottom)) {
  border-bottom: 1px solid #b8c2cc;
}
::v-deep(.vc-container .vc-day:not(.on-bottom).weekday-1) {
  border-bottom: 1px solid #b8c2cc;;
}
::v-deep(.vc-container .vc-day) {
  border-right: 1px solid #b8c2cc;
}
::v-deep(.vc-container .vc-day-dots) {
  margin-bottom: 5px;
}
::v-deep(.in-next-month.is-not-in-month) {
  display: none;  
}
::v-deep(.vc-container .is-today) {
  background-color: #FCA5A5 !important;
}
</style>